import type { PlayerMessage } from '@shared/types.js';

/** הודעה דחופה ישנה כבר לא דחופה: אחרי כמה שעות היא רק עוד שורה ביומן השדה */
export const URGENT_BANNER_MAX_AGE_MS = 12 * 60 * 60 * 1000;

const SEEN_KEY = 'pmr-urgent-seen';

export function readUrgentSeen(): string | null {
  try {
    return localStorage.getItem(SEEN_KEY);
  } catch {
    return null;
  }
}

export function writeUrgentSeen(id: string): void {
  try {
    localStorage.setItem(SEEN_KEY, id);
  } catch {
    // מצב פרטי / אחסון חסום: ההודעה תוצג שוב בטעינה הבאה — עדיף על פני החמצה שלה
  }
}

/**
 * ההודעה הדחופה האחרונה מהמפקדה שהשחקן עוד לא אישר שקרא ושעדיין רלוונטית. רק האחרונה נחשבת: מי שאישר אותה
 * ראה גם את הקודמות ביומן, ואין טעם להציג שוב ושוב הודעות ישנות.
 */
export function pendingUrgentMessage(
  messages: readonly PlayerMessage[],
  seenId: string | null,
  now: number,
): PlayerMessage | null {
  let latest: PlayerMessage | null = null;
  let latestAt = -Infinity;
  for (const m of messages) {
    if (m.sender !== 'admin' || !m.urgent) continue;
    const at = Date.parse(m.sentAt);
    if (!Number.isFinite(at) || at <= latestAt) continue;
    latest = m;
    latestAt = at;
  }
  if (!latest || latest.id === seenId) return null;
  return now - latestAt <= URGENT_BANNER_MAX_AGE_MS ? latest : null;
}
